module.exports = __webpack_public_path__ + "img/wordpress-plain.012709ad.svg";